import React from 'react'
import PromoCreate from '../promo_components/promo_create'
import { Card, CardContent, CardHeader } from '@mui/material'
import WebSidebar from '../../web_sidebar'
export default function
    () {
    return (
        <div>
            <div className='row'>

                <WebSidebar />


                <div className='content-wrapper w-75 bg-white p-5'>
                    <div>
                        <h2>Create Promotion</h2>
                        <PromoCreate />
                    </div>


                </div>
            </div>




        </div>
    )
}
